module.exports = __webpack_public_path__ + "static/media/consumer-landscape.efee273d.jpg";